import 'twin.macro'
import Hundiowidget from '@/components/hundioWidget'
import CtaLink from '@/components/ui/cta-link'
import { useTranslation } from '@/utils/useTranslation'

export default function CloudStatus({ ...rest }): JSX.Element {
  const { t } = useTranslation()
  return (
    <div tw="p-8 [h2]:m-0 bg-gray-100 rounded-4xl mb-8" {...rest}>
      <h3 tw="text-2xl mb-0">{t('Cloud Status')}</h3>
      <div>
        <Hundiowidget />
      </div>
      <CtaLink to="https://status.bitwarden.com/">{t('Check status')}</CtaLink>
    </div>
  )
}
